import { render, staticRenderFns } from "./customer-list-filter.vue?vue&type=template&id=f47f1bbe&"
import script from "./customer-list-filter.vue?vue&type=script&lang=js&"
export * from "./customer-list-filter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports